export default {
  isEmpty(state) {
    return state.list.length === 0;
  },
  cleanInvoices(state) {
    return state.list.map(({ cfdi, id }) => ({ ...cfdi, id }));
  },
  debtsEvents: (state, { cleanInvoices }) => cleanInvoices.map(debt => ({
    ...debt,
    start: debt.operation.expirationDate,
    end: debt.operation.expirationDate,
    debt: debt.operation.payments.reduce((accum, { amount }) => accum - amount, debt.voucherTotal),
  })),
};
